// MobileMenuAddButton.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './MobileMenuAddButton.css';

// Icons
import Icon from 'svg/Icon';

/**
 * MobileMenuAddButton
 *
 * @returns {ReactNode} The rendered component.
 */
const MobileMenuAddButton = ({ onClick, enabled = true }) => {

    // ----- CONTEXT ----- //

    // Theme Context

    const { theme } = useTheme();

    // ----- RENDER ----- //

    return (
        <>
            <div
              className="mobile-menu-add-button-container"
              style={{
                    cursor: enabled ? 'pointer' : 'not-allowed',
                    opacity: enabled ? 1 : 0.45,
                    //backgroundColor: "white",
                    //backgroundColor: "#00000044",
                }}
              title="Add"
              onClick={() => {
                    if (!enabled) return;
                    onClick && onClick();
                }}
            >
                <Icon
                  iconKey="add"
                  color={theme.foreground}
                  width={33}
                  height={33}
                />
            </div>

        </>
    );
};

// Dev Tools
MobileMenuAddButton.displayName = 'MobileMenuAddButton';

export default MobileMenuAddButton;
